import Relay from 'react-relay';

export default class AddProjectMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{createConversation}`;
  }

  getVariables() {
    return {
      name: this.props.name,
      creatorId: this.props.creatorId,
      startDate: this.props.startDate,
      numberOfRespondents: this.props.numberOfRespondents
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on CreateConversationPayload {
        user {
          conversations
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        user: this.props.userRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddProjectMutation.js
 **/